var _excluded = ["type", "inactiveType", "active"],
  _excluded2 = ["type", "clear"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createStyles, PortalBody } from '@udecode/plate-styled-components';
import _styled, { css } from 'styled-components';
import React, { useState, useCallback, useEffect, useRef } from 'react';
import { isSelectionExpanded, getSelectionText, someNode, getPreventDefaultHandler, toggleNodeType, isMarkActive, toggleMark } from '@udecode/plate-common';
import { useStoreEditorState, useEventEditorId } from '@udecode/plate-core';
import { usePopperPosition, getSelectionBoundingClientRect } from '@udecode/plate-popper';
import Tippy from '@tippyjs/react';
var getToolbarStyles = function getToolbarStyles(props) {
  return createStyles(_objectSpread({
    prefixClassNames: 'Toolbar'
  }, props), {
    root: [{
      "display": "flex",
      "alignItems": "center",
      "userSelect": "none",
      "boxSizing": "content-box"
    }, {
      "color": "rgb(68, 68, 68)",
      "minHeight": "40px"
    }]
  });
};
var getBalloonToolbarStyles = function getBalloonToolbarStyles(props) {
  var _props$popperOptions;
  var color = 'rgb(157, 170, 182)';
  var colorActive = 'white';
  var background = 'rgb(36, 42, 49)';
  var borderColor = 'transparent';
  if (props.theme === 'light') {
    color = 'rgba(0, 0, 0, 0.50)';
    colorActive = 'black';
    background = 'rgb(250, 250, 250)';
    borderColor = 'rgb(196, 196, 196)';
  }
  var _ref = (_props$popperOptions = props.popperOptions) !== null && _props$popperOptions !== void 0 ? _props$popperOptions : {},
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement;
  var arrowStyle = [props.arrow && css(["::after{left:50%;content:' ';position:absolute;margin-top:-1px;transform:translateX(-50%);border-color:", " transparent;border-style:solid;}"], background), props.arrow && placement.includes('top') && css(["::after{top:100%;bottom:auto;border-width:8px 8px 0;}"]), props.arrow && !placement.includes('top') && css(["::after{top:auto;bottom:100%;border-width:0 8px 8px;}"])];
  var arrowBorderStyle = [props.arrow && placement.includes('top') && props.theme === 'light' && css(["::before{margin-top:0;border-width:9px 9px 0;border-color:", " transparent;}"], borderColor), props.arrow && !placement.includes('top') && props.theme === 'light' && css(["::before{margin-top:0;border-width:0 9px 9px;border-color:", " transparent;}"], borderColor)];
  return createStyles(_objectSpread({
    prefixClassNames: 'BalloonToolbar'
  }, props), {
    root: [].concat(_toConsumableArray(getToolbarStyles(props).root.css), [{
      "position": "absolute",
      "whiteSpace": "nowrap",
      "opacity": "1",
      "transition": "opacity .2s ease-in-out"
    }, css(["color:", ";background:", ";z-index:500;border:1px solid ", ";border-radius:4px;.slate-ToolbarButton-active,.slate-ToolbarButton:hover{color:", ";}::before{", "}"], color, background, borderColor, colorActive, arrowBorderStyle)], arrowStyle, arrowBorderStyle)
  });
};
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var ToolbarBase = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("div", _extends({
    "data-testid": "Toolbar",
    ref: ref
  }, props));
});
var _StyledToolbarBase$2 = _styled(ToolbarBase).withConfig({
  displayName: "Toolbar___StyledToolbarBase",
  componentId: "sc-1wna77d-0"
})(["", ""], function (p) {
  return p.$_css;
});
var Toolbar = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _getToolbarStyles = getToolbarStyles(props),
    root = _getToolbarStyles.root;
  return /*#__PURE__*/React.createElement(_StyledToolbarBase$2, _extends({}, props, {
    ref: ref,
    className: root.className,
    $_css: root.css
  }));
});
var useBalloonToolbarPopper = function useBalloonToolbarPopper(options) {
  var _selectionText$length;
  var editor = useStoreEditorState(useEventEditorId('focus'));
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isHidden = _useState2[0],
    setIsHidden = _useState2[1];
  var selectionExpanded = editor && isSelectionExpanded(editor);
  var selectionText = editor && getSelectionText(editor);
  var show = useCallback(function () {
    if (isHidden && selectionExpanded) {
      setIsHidden(false);
    }
  }, [isHidden, selectionExpanded]);
  useEffect(function () {
    if (!selectionText) {
      setIsHidden(true);
    } else if (selectionText && selectionExpanded) {
      setIsHidden(false);
    }
  }, [selectionExpanded, selectionText, show]);
  var popperResult = usePopperPosition(_objectSpread({
    isHidden: isHidden,
    getBoundingClientRect: getSelectionBoundingClientRect
  }, options));
  var selectionTextLength = (_selectionText$length = selectionText === null || selectionText === void 0 ? void 0 : selectionText.length) !== null && _selectionText$length !== void 0 ? _selectionText$length : 0;
  var update = popperResult.update;
  useEffect(function () {
    selectionTextLength > 0 && (update === null || update === void 0 ? void 0 : update());
  }, [selectionTextLength, update]);
  return popperResult;
};
var BalloonToolbar = function BalloonToolbar(props) {
  var children = props.children,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? 'dark' : _props$theme,
    _props$arrow = props.arrow,
    arrow = _props$arrow === void 0 ? false : _props$arrow,
    portalElement = props.portalElement,
    _props$popperOptions2 = props.popperOptions,
    _popperOptions = _props$popperOptions2 === void 0 ? {} : _props$popperOptions2;
  var popperRef = useRef(null);
  var popperOptions = _objectSpread({
    popperElement: popperRef.current,
    placement: 'top',
    offset: [0, 8]
  }, _popperOptions);
  var _useBalloonToolbarPop = useBalloonToolbarPopper(popperOptions),
    popperStyles = _useBalloonToolbarPop.styles,
    attributes = _useBalloonToolbarPop.attributes;
  var styles = getBalloonToolbarStyles(_objectSpread({
    popperOptions: popperOptions,
    theme: theme,
    arrow: arrow
  }, props));
  return /*#__PURE__*/React.createElement(PortalBody, {
    element: portalElement
  }, /*#__PURE__*/React.createElement(_StyledToolbarBase$1, _extends({
    ref: popperRef,
    className: styles.root.className,
    style: popperStyles.popper
  }, attributes.popper, {
    $_css: styles.root.css
  }), children));
};
var _StyledToolbarBase$1 = _styled(ToolbarBase).withConfig({
  displayName: "BalloonToolbar___StyledToolbarBase",
  componentId: "sc-8umnsm-0"
})(["", ""], function (p) {
  return p.$_css;
});
var getHeadingToolbarStyles = function getHeadingToolbarStyles(props) {
  return createStyles(_objectSpread({
    prefixClassNames: 'HeadingToolbar'
  }, props), [{
    root: [].concat(_toConsumableArray(getToolbarStyles(props).root.css), [{
      "position": "relative",
      "flexWrap": "wrap",
      "marginTop": "0px",
      "marginBottom": "1.25rem",
      "marginLeft": "-1.25rem",
      "marginRight": "-1.25rem"
    }, css(["padding:1px 18px 17px;border-bottom:2px solid #eee;.slate-ToolbarButton-active,.slate-ToolbarButton:hover{color:#06c;}"])])
  }]);
};
var HeadingToolbar = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var styles = getHeadingToolbarStyles(props);
  return /*#__PURE__*/React.createElement(_StyledToolbarBase, _extends({
    ref: ref,
    className: styles.root.className
  }, props, {
    $_css: styles.root.css
  }));
});
var _StyledToolbarBase = _styled(ToolbarBase).withConfig({
  displayName: "HeadingToolbar___StyledToolbarBase",
  componentId: "sc-g9jzcf-0"
})(["", ""], function (p) {
  return p.$_css;
});
var getToolbarButtonStyles = function getToolbarButtonStyles(props) {
  return createStyles(_objectSpread({
    prefixClassNames: 'ToolbarButton'
  }, props), _objectSpread({
    root: [{
      "display": "flex",
      "justifyContent": "center",
      "alignItems": "center",
      "userSelect": "none",
      "cursor": "pointer",
      "verticalAlign": "middle"
    }, {
      "width": "28px",
      "height": "24px"
    }, css(["> svg{", "}"], {
      "display": "block",
      "width": "1.25rem",
      "height": "1.25rem"
    })]
  }, props.active && {
    active: {}
  }));
};
function toVal(mix) {
  var k,
    y,
    str = '';
  if (typeof mix === 'string' || typeof mix === 'number') {
    str += mix;
  } else if (_typeof(mix) === 'object') {
    if (Array.isArray(mix)) {
      for (k = 0; k < mix.length; k++) {
        if (mix[k]) {
          if (y = toVal(mix[k])) {
            str && (str += ' ');
            str += y;
          }
        }
      }
    } else {
      for (k in mix) {
        if (mix[k]) {
          str && (str += ' ');
          str += k;
        }
      }
    }
  }
  return str;
}
function clsx() {
  var i = 0,
    tmp,
    x,
    str = '';
  while (i < arguments.length) {
    if (tmp = arguments[i++]) {
      if (x = toVal(tmp)) {
        str && (str += ' ');
        str += x;
      }
    }
  }
  return str;
}
var ToolbarButton = function ToolbarButton(props) {
  var icon = props.icon,
    tooltip = props.tooltip,
    onMouseDown = props.onMouseDown,
    _props$as = props.as,
    as = _props$as === void 0 ? 'span' : _props$as;
  var spanProps = {
    onMouseDown: onMouseDown
  };
  var tooltipProps = _objectSpread({
    content: '',
    arrow: true,
    offset: [0, 17],
    delay: 0,
    duration: [200, 0],
    hideOnClick: false
  }, tooltip);
  var _getToolbarButtonStyl = getToolbarButtonStyles(props),
    root = _getToolbarButtonStyl.root,
    active = _getToolbarButtonStyl.active;
  var button = /*#__PURE__*/React.createElement(_StyledSpan, _extends({
    "data-testid": "ToolbarButton",
    as: as,
    className: clsx(root.className, active === null || active === void 0 ? void 0 : active.className)
  }, spanProps, {
    $_css: root.css
  }), icon);
  return tooltip ? /*#__PURE__*/React.createElement(Tippy, tooltipProps, button) : button;
};
var _StyledSpan = _styled("span").withConfig({
  displayName: "ToolbarButton___StyledSpan",
  componentId: "sc-15em9do-0"
})(["", ""], function (p) {
  return p.$_css;
});
var ToolbarDropdown = function ToolbarDropdown(_ref2) {
  var control = _ref2.control,
    children = _ref2.children,
    onClose = _ref2.onClose;
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    referenceElement = _useState4[0],
    setReferenceElement = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    popperElement = _useState6[0],
    setPopperElement = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    open = _useState8[0],
    setOpen = _useState8[1];
  useEffect(function () {
    var listener = function listener(ev) {
      if (open) {
        if (referenceElement && ev.composedPath().includes(referenceElement)) {
          return;
        }
        if (popperElement && ev.composedPath().includes(popperElement)) {
          return;
        }
        setOpen(false);
        onClose === null || onClose === void 0 ? void 0 : onClose(ev);
      }
    };
    document.body.addEventListener('mousedown', listener);
    return function () {
      document.body.removeEventListener('mousedown', listener);
    };
  }, [onClose, open, popperElement, referenceElement, setOpen]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: setReferenceElement,
    onMouseDown: function onMouseDown() {
      return setOpen(true);
    }
  }, control), /*#__PURE__*/React.createElement(_StyledDiv, {
    ref: setPopperElement,
    $_css: [{
      "position": "absolute",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgba(255, 255, 255, var(--tw-bg-opacity))",
      "top": "2.5rem"
    }, !open && {
      "display": "none"
    }, css(["border:1px solid #ccc;box-shadow:0 1px 3px 0 #ccc;z-index:1;"])]
  }, children));
};
var _StyledDiv = _styled("div").withConfig({
  displayName: "ToolbarDropdown___StyledDiv",
  componentId: "sc-3ansxp-0"
})(["", ""], function (p) {
  return p.$_css;
});

/**
 * Toolbar button to toggle the type of elements in selection.
 */
var ToolbarElement = function ToolbarElement(_ref3) {
  var type = _ref3.type,
    inactiveType = _ref3.inactiveType,
    active = _ref3.active,
    props = _objectWithoutProperties(_ref3, _excluded);
  var editor = useStoreEditorState(useEventEditorId('focus'));
  return /*#__PURE__*/React.createElement(ToolbarButton, _extends({
    active: active !== null && active !== void 0 ? active : !!(editor !== null && editor !== void 0 && editor.selection) && someNode(editor, {
      match: {
        type: type
      }
    }),
    onMouseDown: editor && getPreventDefaultHandler(toggleNodeType, editor, {
      activeType: type,
      inactiveType: inactiveType
    })
  }, props));
};

/**
 * Toolbar button to toggle the mark of the leaves in selection.
 */
var ToolbarMark = function ToolbarMark(_ref4) {
  var type = _ref4.type,
    clear = _ref4.clear,
    props = _objectWithoutProperties(_ref4, _excluded2);
  var editor = useStoreEditorState(useEventEditorId('focus'));
  return /*#__PURE__*/React.createElement(ToolbarButton, _extends({
    active: !!(editor !== null && editor !== void 0 && editor.selection) && isMarkActive(editor, type),
    onMouseDown: editor ? getPreventDefaultHandler(toggleMark, editor, type, clear) : undefined
  }, props));
};
export { BalloonToolbar, HeadingToolbar, Toolbar, ToolbarBase, ToolbarButton, ToolbarDropdown, ToolbarElement, ToolbarMark, getBalloonToolbarStyles, getHeadingToolbarStyles, getToolbarButtonStyles, getToolbarStyles, useBalloonToolbarPopper };